import React from 'react';
import Header from '../../../shared/components/layout/Header';
import Footer from '../../../shared/components/layout/Footer';
import BandejaVerificacionOme from '../components/BandejaVerificacionOme';

/**
 * Página de ruta de la bandeja "OME por verificar" (flujo PAMI).
 *
 * Componente de ruta: se usa únicamente en el router. Envuelve la bandeja
 * con el layout general (Header / Footer) del sistema.
 */
const VerificacionOmePage = () => {
  return (
    <>
      <Header />
      <BandejaVerificacionOme />
      <Footer />
    </>
  );
};

export default VerificacionOmePage;
